import React, { useState, useEffect } from 'react';
import { SlCalender } from "react-icons/sl";

import { timeStampToDate } from "../pdpComponents/utils.jsx";


const ForeclosureDetails = ({ listingDetails }) => {
   

    return (

        <div >
            <div className="">
        
                <h4 style={{textAlign:'center'}} className='fc-calendar-details'>  <SlCalender size={24}/>  {'    '}Auction Duration</h4>
                <p style={{textAlign:'center'}} className='fc-calendar-duration '> {timeStampToDate(listingDetails.startDate)
                               + '-' +
                               timeStampToDate(listingDetails.endDate)
                               }</p>
              

            </div>
           
        </div>


    );


};

export default ForeclosureDetails;

